export function validaCPF(cpf) {

  if (cpf == null)
    return false

  // Remove caracteres não numéricos do CPF
  cpf = cpf.replace(/[^\d]/g, '');

  // Verifica se o CPF tem 11 dígitos
  if (cpf.length !== 11) {
    return false;
  }

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cpf)) {
    return false;
  }

  // Calcula o primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let primeiroDigito = (soma * 10) % 11;
  if (primeiroDigito === 10) {
    primeiroDigito = 0;
  }
  if (primeiroDigito !== parseInt(cpf.charAt(9))) {
    return false;
  }

  // Calcula o segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  let segundoDigito = (soma * 10) % 11;
  if (segundoDigito === 10) {
    segundoDigito = 0;
  }
  if (segundoDigito !== parseInt(cpf.charAt(10))) {
    return false;
  }

  // Se passou por todas as validações, o CPF é válido
  return true;
}

export function formatDateComHoras(date, br) {
  var dia = date.getDate()
  var mes = date.getMonth() + 1
  var ano = date.getFullYear()

  if(dia < 10) dia = "0" + dia
  if(mes < 10) mes = "0" + mes

  var horas = date.getHours()
  var minutos = date.getMinutes()
  // var segundos = date.se

  if(horas < 10) horas = "0" + horas
  if(minutos < 10) minutos = "0" + minutos

  var texto
  if(br) {
    texto =  dia + "/"+mes+"/"+(ano.toString().substring(2, 4)) + " - " + horas + ":" + minutos
  } else {
    texto = (ano.toString().substring(2, 4)) + "/"+mes+"/"+dia + " - " + horas + ":" + minutos
  }

  return texto
}

export function formatDateJavaComHoras(string) {
  return formatDateComHoras(new Date(string), true)
}

export function interpolarCor(valor) {  
  // Garante que o valor esteja no intervalo de 0 a 100
  valor = Math.min(100, Math.max(0, valor));

  // Cores em formato RGB
  const rgbVermelho = [194, 0, 0];          // Vermelho escuro
  const rgbAmarelo = [255, 204, 0];         // Amarelo mostarda
  const rgbVerde = [0, 102, 0];             // Verde escuro

  // Interpolação linear entre as cores base com base no valor
  let rgbInterpolado;
  const separador = 80
  if (valor <= separador) {
    rgbInterpolado = [
      Math.round((rgbAmarelo[0] - rgbVermelho[0]) * (valor / separador) + rgbVermelho[0]),
      Math.round((rgbAmarelo[1] - rgbVermelho[1]) * (valor / separador) + rgbVermelho[1]),
      Math.round((rgbAmarelo[2] - rgbVermelho[2]) * (valor / separador) + rgbVermelho[2])
    ];
  } else {
    rgbInterpolado = [
      Math.round((rgbVerde[0] - rgbAmarelo[0]) * ((valor - separador) / 20) + rgbAmarelo[0]),
      Math.round((rgbVerde[1] - rgbAmarelo[1]) * ((valor - separador) / 20) + rgbAmarelo[1]),
      Math.round((rgbVerde[2] - rgbAmarelo[2]) * ((valor - separador) / 20) + rgbAmarelo[2])
    ];
  }

  return `rgb(${rgbInterpolado.join(',')})`;

}

export function isNotNull (obj) {
  return typeof(obj) != undefined && obj != null;
}

export function isNull(obj) {
  return !isNotNull(obj)
}

export function formatDateSemHoras(date) {

  //Corrige datas com dias e mes inferiores a zero e sem 2 casas"
  var split = date.split("T")
  if(split.length === 2) {
    var d = split[0].split("-")
    if(d.length === 3) {
      var ano = parseInt(d[0])
      var mes = parseInt(d[1])
      var dia = parseInt(d[2])

      if(mes < 10) mes = "0"+mes
      if(dia < 10) dia = "0"+dia

      date = ano+"-"+mes+"-"+dia+"T"+split[1]
    }
  }

  if(typeof(date) == "string") {
      date = new Date(date)
  }
  
  var dia = date.getDate()
  var mes = date.getMonth() + 1
  var ano = date.getFullYear()

  if(dia < 10) dia = "0" + dia
  if(mes < 10) mes = "0" + mes

  var texto = dia + "/" + mes + "/" + ano
  return texto
}
